import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { getVideoSingle, updateVideo } from "../../../../services/video";
import { useEffect, useState } from "react";
import { emptyVideo, Video, VideoTag } from "../../../../interfaces/video";
import Uploader from "../../../general/uploader";
import { Media } from "../../../../interfaces/media";
import { LoadingSpinner } from "../../../general/loading-spinner";
import { VideoTagPicker } from "../../../general/video-tag-picker";

interface AdminVideoEditProps {
    id: number;
    tags: VideoTag[];
    onSave: CallableFunction;
    onClose: CallableFunction;
    onTagCreated?: (tag: VideoTag) => void;
    onTagUpdated?: (tag: VideoTag) => void;
    onTagDeleted?: (tagId: number) => void;
}

export function AdminVideoEdit(props: AdminVideoEditProps) {
    const [video, setVideo] = useState<Video>(emptyVideo);
    const [media, setMedia] = useState<Media[]>([]);
    const [selectedTagIds, setSelectedTagIds] = useState<number[]>([]);

    useEffect(() => {
        getVideoSingle(props.id)
            .then(response => {
                const newMedia = response.data.media.map((m: Media) => {
                    return m;
                });
                setMedia(newMedia);
                setVideo(response.data);
                setSelectedTagIds((response.data.tags || []).map((t: VideoTag) => t.id));
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    const handleSave = (event: any) => {
        event.preventDefault();

        if (media.length == 0) {
            alert(t("video_mandatory_alert"));
            return false;
        }

        const body = {
            id: event.target.id.value,
            name: event.target.name.value,
            description: event.target.description.value,
            media: media.length > 0 ? media[0].id : 0,
            tags: selectedTagIds
        }
        updateVideo(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleClose = () => {
        props.onClose();
    }

    const handleMediaEventUpload = (media: Media[]) => {
        if (media.length > 1) {
            alert(t("single_image_warning"));
        } else {
            const newMedia = media.map((m: Media) => { return m; });
            setMedia(newMedia);
        }
    }

    return (
        <Modal className="admin-video-edit-container" show={ true }
            onHide={ handleClose }>
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("edit_video") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { video.id == 0 &&
                    <LoadingSpinner />
                }
                { video.id != 0 &&
                    <Form onSubmit={ handleSave }>
                        <div className="fields">
                            <Form.Group className="mb-3" controlId="id">
                                <Form.Control type="hidden" name="id" required
                                    defaultValue={ video.id } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="name">
                                <Form.Label aria-required="true">{ t("Name") }</Form.Label>
                                <Form.Control type="text" name="name" required
                                    defaultValue={ video.name } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="description">
                                <Form.Label>{ t("description") }</Form.Label>
                                <Form.Control name="description" as="textarea"
                                    defaultValue={ video.description } />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>{ t("Tags") }</Form.Label>
                                <VideoTagPicker
                                    tags={props.tags}
                                    selectedTagIds={selectedTagIds}
                                    onChange={setSelectedTagIds}
                                    allowCreate={true}
                                    allowManage={true}
                                    onTagCreated={props.onTagCreated}
                                    onTagUpdated={props.onTagUpdated}
                                    onTagDeleted={props.onTagDeleted}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3 media-field" controlId="media">
                                <Uploader title={ t("video_upload_message") }
                                    media={ media } save={ handleMediaEventUpload } />
                            </Form.Group>
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Save") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}
